export default __webpack_public_path__ + "static/media/technologies.83bdd452.png";